import { render, staticRenderFns } from "./TrainingPlanItemNutritionPlaceholder.vue?vue&type=template&id=d0f29ef0&"
import script from "./TrainingPlanItemNutritionPlaceholder.vue?vue&type=script&lang=ts&"
export * from "./TrainingPlanItemNutritionPlaceholder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports